import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const CallToAction = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="bg-[#EDF2FA] m-14 py-16 px-6">
      <div className="max-w-4xl mx-auto text-center">
        {loading ? (
          <>
            <Skeleton height={36} width={320} className="mb-4 mx-auto" style={{ marginBottom: 16, borderRadius: 8 }} />
            <Skeleton height={20} width={260} className="mb-6 mx-auto" style={{ marginBottom: 24, borderRadius: 8 }} />
            <Skeleton height={48} width={180} style={{ borderRadius: 24, margin: '0 auto' }} />
          </>
        ) : (
          <>
            <h2 className="text-2xl md:text-3xl font-bold text-[#003A7D] mb-4">
              Let’s build together.
            </h2>
            <p className="text-sm md:text-base text-[#003A7D] mb-6">
              Tell us your vision, and we’ll help you build it.
            </p>
            <button
              className="bg-[#003A7D] text-white px-6 py-3 hover:bg-blue-900 transition font-semibold text-sm"
              onClick={() => window.location.href = '/contact'}
            >
              CONTACT US
            </button>
          </>
        )}
      </div>
    </section>
  );
};

export default CallToAction;
